import Vue from 'vue';
const state = {
    product: {
        brand: {},
        distributor: {}
    },
    products: [],
    favorites: [],
}
const actions = {
    showProducts: (context, trashed = false) => {
        context.commit('SHOW_PRODUCTS', [])
        return new Promise((resolve, reject) => {
            axios.get(`/api/products${trashed ? '?trashed' : ''}`).then(response => {
                context.commit('SHOW_PRODUCTS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showFavoriteProducts: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/products/favorites`).then(response => {
                context.commit('SHOW_FAVORITE_PRODUCTS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showProduct: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/products/${id}`).then(response => {
                context.commit('SHOW_PRODUCT', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    searchProduct: (context, ean) => {
        return new Promise((resolve, reject) => {
            if (!ean) {
                return false;
            }

            let barcode =
                ean.length > 3 && ean.charAt(0) == 2 ? ean.substring(1, 7) : ean;

            axios.get(`/api/search/ean/${barcode}`).then(response => {
                context.commit('SHOW_PRODUCT', response.data.data)
                resolve(response)
            }).catch(error => {
                Vue.$toast.error("Produto não encontrado");
                reject(error)
            })
        })
    },
    storeProduct: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/products`, payload).then(response => {
                context.commit('STORE_PRODUCT', response.data)
                context.dispatch('showProducts')
                Vue.$toast.success("Produto cadastrado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateProduct: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/products/${payload.id}`, payload).then(response => {
                context.dispatch('showProducts')
                Vue.$toast.info("Produto atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateMultipleProducts: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/products/multiple`, payload).then(response => {
                context.dispatch('showProducts')
                Vue.$toast.info("Produtos atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateStock: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/products/${payload.id}/stock`, payload).then(response => {
                context.dispatch('showProduct', payload.id)
                Vue.$toast.info("Estoque atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePrice: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/products/${payload.id}/price`, payload).then(response => {
                context.dispatch('showProduct', payload.id)
                Vue.$toast.info("Preço atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyProduct: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/products/${id}`).then(response => {
                context.dispatch('showProducts')
                Vue.$toast.error("Produto deletado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    restoreProduct: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/products/${id}/restore`).then(response => {
                context.dispatch('showProducts')
                Vue.$toast.success("Produto restaurado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_PRODUCT: (state, payload) => {
        state.product = payload
    },
    SHOW_PRODUCTS: (state, payload) => {
        state.products = payload
    },
    SHOW_FAVORITE_PRODUCTS: (state, payload) => {
        state.favorites = payload
    },
    STORE_PRODUCT: (state, payload) => {
        state.product = payload
    }
}
const getters = {
    product: state => {
        return state.product
    },
    products: state => {
        return state.products
    },
    favorites: state => {
        return state.favorites
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}